import { $ } from './../helpers/query'
import { gsap } from 'gsap'

export default class {
  constructor() {
    this.progressbar = document.querySelector('.progressbar');
    this.thumb = this.progressbar.querySelector('.progressbar__thumb');
    this.content = document.querySelector('#fullpage');
    this.sections = this.content.querySelectorAll('.fullpage__section');
    this.thumbStartWidth = this.thumb.offsetWidth;
  }

  bindEvents() {
    if (document.documentElement.clientWidth < 640) {
      this.updateInDefault()
    }
    window.addEventListener('scroll', (e) => {
      if (document.documentElement.clientWidth < 640) {
        this.updateInDefault()
      }
    })
  }

  updateInFullpage(destination) {
    let scrollHeight = 0;
    let scrollTop = 0;
    let stopSection = false;
    this.sections.forEach((section, i) => {
      scrollHeight += section.offsetHeight;
      if (!stopSection) {
        scrollTop += section.offsetHeight;
      }
      if (section == destination) {
        stopSection = true;
      }
    });
    scrollHeight -= this.content.offsetHeight;
    scrollTop -= this.content.offsetHeight;
    const progressWidth = this.progressbar.offsetWidth - this.thumbStartWidth;
    const progressCurrent = scrollTop * progressWidth / scrollHeight;
    gsap.to(this.thumb, {
      width: this.thumbStartWidth + progressCurrent + 'px',
      duration: 0.6
    })
  }

  updateInDefault() {
    let scrollHeight = 0;
    this.sections.forEach((section, i) => {
      scrollHeight += section.offsetHeight;
    });
    scrollHeight -= document.documentElement.clientHeight;
    const progressWidth = this.progressbar.offsetWidth - this.thumbStartWidth;
    const scrollTop = window.pageYOffset;
    const progressCurrent = scrollTop * progressWidth / scrollHeight;
    gsap.to(this.thumb, {
      width: this.thumbStartWidth + progressCurrent + 'px',
      duration: 0.2
    })
  }
}
